export default __webpack_public_path__ + "static/media/kamila-camillo.aba64b86.ogg";